import * as React from 'react';

import { calculateTotalTransactions } from '../../../providers/TransactionsProvider';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface ITotalTransactionsRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
}

const TotalTransactionsRow = ({ transactions, dateRange }: ITotalTransactionsRowProps) => {
  const value = React.useMemo(() => calculateTotalTransactions(transactions, dateRange), [transactions, dateRange]);

  return <Widget.Row label="Transactions" value={value} />;
};

export default TotalTransactionsRow;
